enum PhoneOtpActionTypes {
  UPDATE_OTP_VALUE = 'UPDATE_OTP_VALUE',
  RESEND_SUCCESS = 'RESEND_SUCCESS',
  VERIFICATION_ERROR = 'VERIFICATION_ERROR',
  VERIFICATION_LOADING = 'VERIFICATION_LOADING',
}

interface PhoneOtpState {
  resendSuccess: boolean;
  otpValue: string;
  otpVerificationError: string | null;
  verificationLoading: boolean;
}

type PhoneOtpActions =
  | {
      type: PhoneOtpActionTypes.UPDATE_OTP_VALUE;
      payload: {
        value: string;
      };
    }
  | {
      type: PhoneOtpActionTypes.RESEND_SUCCESS;
      payload: {
        value: boolean;
      };
    }
  | {
      type: PhoneOtpActionTypes.VERIFICATION_ERROR;
      payload: {
        value: PhoneOtpState['otpVerificationError'];
      };
    }
  | {
      type: PhoneOtpActionTypes.VERIFICATION_LOADING;
      payload: {
        value: PhoneOtpState['verificationLoading'];
      };
    };

export { PhoneOtpActionTypes };
export type { PhoneOtpActions, PhoneOtpState };
